<template>
	<div id="main-page">
		<header>
			<a href="https://lenta.ru/" @click="linkClick('https://lenta.ru/')" target="_blank">
				<img src="../assets/images/lenta.svg">
			</a>
			
			<a
				href="https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_campaign=KIA_Sportage_Tactic_December_2018"
				@click="linkClick('https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_campaign=KIA_Sportage_Tactic_December_2018')"
				target="_blank"
			>
				<img src="../assets/images/kia.svg">
			</a>

			<shares class="shares"/>
		</header>

		<div class="content">
			<div class="title">Твой успех</div>
			<div
				class="text"
			>Хочешь оказаться на пике своих увлечений? Написать первую в жизни песню, научиться создавать крутые бизнес-проекты или придумать что-то столь же современное и красивое, как и Новый KIA Sportage?
				<br>Выбери себе программу и действуй!
			</div>
			<div class="nav">
				<router-link to="/sport" @click="linkClick('sport')">Спорт</router-link>
				<div class="devider"></div>
				<router-link to="/career" @click="linkClick('career')">Карьера</router-link>
				<div class="devider"></div>
				<router-link to="/family" @click="linkClick('family')">Семья</router-link>
				<div class="devider"></div>
				<router-link to="/business" @click="linkClick('business')">Бизнес</router-link>
				<div class="devider"></div>
				<router-link to="/art" @click="linkClick('art')">Творчество</router-link>
			</div>
			<a
				href="https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_campaign=KIA_Sportage_Tactic_December_2018"
				target="_blank"
				class="btn"
			>Подробнее о KIA Sportage</a>
		</div>
	</div>
</template>


<script>
import ContentView from '@/components/Content'
import shareMixin from '@/mixins/shares'
import Shares from '@/components/Shares'

export default {
	name: 'Main',
	components: {
		Shares,
	},
	mixins: [shareMixin],
	data() {
		return {}
	},
}
</script>


<style lang="less" scoped>
#main-page {
	width: 100vw;
	height: 100vh;
	background-image: url(../assets/images/main-bg.jpg);
	background-size: cover;
	background-position: center;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (max-width: 667px) {
		height: auto;
		background-image: url(../assets/images/main-bg-mobile.jpg);
		background-position: left top;
		background-size: 100%;
		background-repeat: no-repeat;
	}
}

.content {
	width: 96%;
	max-width: 1300px;
	text-align: center;
	transform: translateY(10vh);

	.title {
		font-size: 130px;
		text-transform: uppercase;
		font-weight: bold;

		@media (max-width: 667px) {
			font-size: 60px;
			padding-top: 30vh;
			padding-bottom: 20px;
		}
	}

	.text {
		font-size: 20px;
		line-height: 26px;
		max-width: 820px;
		margin: 0 auto;

		@media (max-width: 667px) {
			font-size: 18px;
		}
	}

	.nav {
		margin: 30px 0;
		display: flex;
		justify-content: center;
		align-items: center;

		@media (max-width: 667px) {
			flex-direction: column;
		}

		a {
			padding: 25px;
			font-size: 20px;
			letter-spacing: 4px;
			text-transform: uppercase;
			position: relative;
			transition: all 300ms ease;

			@media (max-width: 667px) {
				padding: 15px;
			}
		}

		a:before {
			content: '+';
			position: absolute;
			color: #dc1d18;
			left: 8px;
			opacity: 0;
			transition: opacity 300ms ease;
		}

		a:after {
			content: '+';
			position: absolute;
			color: #dc1d18;
			right: 8px;
			opacity: 0;
			transition: opacity 300ms ease;
		}

		a:hover {
			color: #dc1d18;
		}

		a:hover:before {
			opacity: 1;
		}

		a:hover:after {
			opacity: 1;
		}

		.devider {
			height: 1px;
			background: #fff;
			flex-grow: 1;
		}
	}

	.btn {
		width: 96%;
		max-width: 360px;
		border: 1px solid #fff;
		padding: 30px 0;
		margin: 0 auto;
		margin-top: 30px;
		display: block;
		transition: all 300ms ease;
		text-transform: uppercase;
		font-size: 14px;
		letter-spacing: 4px;

		@media (max-width: 667px) {
			font-size: 12px;
			margin-bottom: 40px;
		}
	}

	.btn:hover {
		background: #dc1d18;
		border: 1px solid #dc1d18;
	}
}

header {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	padding: 20px;
	box-sizing: border-box;
	z-index: 2;

	@media (min-width: 1200px) {
		padding: 40px 30px;
	}

	@media (max-width: 667px) {
		flex-direction: column;
		align-items: flex-start;
	}

	a {
		width: 65px;

		@media (min-width: 720px) {
			width: 80px;
		}

		@media (max-width: 667px) {
			margin-bottom: 10px;
		}

		&:first-of-type {
			@media (min-width: 720px) {
				margin-right: 40px;
			}
		}

		img {
			width: 100%;
		}
	}

	.shares {
		margin-left: auto;

		@media (max-width: 667px) {
			position: absolute;
			right: 10px;
		}
	}
}
</style>
